import { Airdrop } from '../../types'
import { AirdropBadgeLayout } from './AirdropBadgeLayout'

interface AirdropBadgeDynamicProps {
  airdrop?: Airdrop
  className?: string
  closeMobileMenu?: () => void
}
export function DynamicAirdropBadge({ className, closeMobileMenu }: AirdropBadgeDynamicProps) {
  return <AirdropBadgeLayout isLoading={false} className={className} closeMobileMenu={closeMobileMenu} />
}
